import React from 'react';
import SimulationsContainer from '../components/simulations/SimulationsContainer';

const SimulationsPage: React.FC = () => {
  return <SimulationsContainer />;
};

export default SimulationsPage;